import { useSelector } from 'react-redux';
import { Link } from 'ui/links';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';
import { selectIsLoading } from '../selectors';
import { MetricBreakdownCard } from './MetricBreakdownCard';
import { MetricList, MetricRow, SkeletonWrapper, StyledListContainer } from './Styled';

type GoalsCardProps = {
  goals: string[];
};

const GoalContainer = styled.div`
  margin: ${spacing.base} ${spacing.plusHalf} ${spacing.half};
`;

export const GoalsCard = ({ goals }: GoalsCardProps) => {
  const isLoading = useSelector(selectIsLoading);
  const cardHeight = isLoading ? 250 : 'auto';

  return (
    <MetricBreakdownCard title="Goals">
      {isLoading ? (
        // @ts-expect-error
        <SkeletonWrapper height={cardHeight} padding={24}>
          <Skeleton />
        </SkeletonWrapper>
      ) : (
        <GoalContainer>
          <StyledListContainer useHorizontalCardPadding>
            {goals.map((goal) => (
              <MetricList key={goal}>
                <MetricRow>
                  <span>{goal}</span>
                  <span>
                    <Link
                      useReactRouter
                      hasOpenNewTabIcon
                      target="_blank"
                      href={`/analytics/goalPerformance?goalName=${encodeURIComponent(
                        goal,
                      )}&referrer=campaign-analytics`}
                    >
                      View details
                    </Link>
                  </span>
                </MetricRow>
              </MetricList>
            ))}
          </StyledListContainer>
        </GoalContainer>
      )}
    </MetricBreakdownCard>
  );
};
